import { IconImagesOutline18 as ImagesIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const imageGalleryCommand: SlashCommandDefinition = {
	key: "image-gallery",
	title: "Image gallery",
	aliases: ["carousel", "gallery", "screenshots", "slider"],
	icon: <ImagesIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).run()

		// The file picker is async, so the position is captured before it opens.
		const insertPos = editor.state.selection.from

		window.dispatchEvent(
			new CustomEvent("gallery-upload-request", {
				detail: { editor, insertPos },
			}),
		)
	},
	group: "media",
}
